import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchWithQuizePage as asyncGetQuizeWithFilter,
  getQuizeWithIDS as asyncGetQuizeWithId,
  updateQuize as asyncUpdateQuize,
  getQuizeWithFilter as asyncQuizewithFilter,
  fetchQuizeWithPage as  asyncGetQuizewithfilter,
  // generateRandom as asyncrandomeQuestionGenerate,
  // getQuizeINFOWithIDS  as  asyncQuizeInfo,
  createQuize as asyncCreateQuize,
  deleteQuize as asyncDeleteQuize,
  // bulkDeleteQuize as asyncBulkDeleteQuize,
} from "../../helpers/apis";
import { toast } from 'react-toastify';
import { showToast } from "../toast/reducer";

// Thunk for fetching quizzes with filter
export const getQuizeWithFilter = createAsyncThunk(
  "getQuizeWithFilter",
  async (req, thunkAPI) => {
    try {
      const response = await asyncQuizewithFilter(req);
      console.log("QUIZEDATA_________>>>",response);
      return response;
    } catch (error) {
      thunkAPI.dispatch(showToast({ type: "error", msg: error?.msg || "Error fetching quizzes" }));
      throw error;
    }
  }
);




export const fetchQuizeWithPage = createAsyncThunk(
  "getQuestionPage",
  async (req = { currentPage: 1, perPage: 20 }, thunkAPI) => {
    try {
      const { currentPage, perPage, ...filters } = req;
      const response = await asyncGetQuizewithfilter({
        ...filters,
        currentPage,
        perPage,
      });
      return response;
    } catch (error) {
      thunkAPI.dispatch(
        showToast({ type: "error", msg: error?.msg || "Error fetching question results" })
      );
      throw error;
    }
  }
);


// Thunk for creating a quize
export const createQuize = createAsyncThunk(
  "createQuize",
  async (data, thunkAPI) => {
    console.log(data);
    try {
      const response = await asyncCreateQuize(data);
      thunkAPI.dispatch(showToast({ type: "success", msg: response.msg || "Quize created successfully!" }));
      console.log(response);
      return response;
    } catch (error) {
      thunkAPI.dispatch(showToast({ type: "error", msg: error?.msg || "Error creating quize" }));
      throw error;
    }
  }
);


// Thunk for updating a quize
export const updateQuize = createAsyncThunk(
  "updateQuize",
  async (data, thunkAPI) => {
    try {
      console.log("update DATA:::::->->",data);
      const response = await asyncUpdateQuize(data);
      thunkAPI.dispatch(showToast({ type: "success", msg: response.msg || "Quize updated successfully" }));
      console.log("update::::->",response);
      return response;
    } catch (error) {
      thunkAPI.dispatch(showToast({ type: "error", msg: error.msg || error.message || "Error updating quize" }));
      throw error;
    }
  }
);

// Thunk for fetching single quize by ID
// export const getQuizeINFOWithIDS = createAsyncThunk(
//   "getDetailedById",
//   async (id, thunkAPI) => {
//     try {
//       const response = await asyncQuizeInfo(id);
//       console.log(id);
//       console.log("details:"+response);
//       return response;
//     } catch (error) {
//       thunkAPI.dispatch(showToast({ type: "error", msg: error?.msg || "Error fetching quize by ID" }));
//       throw error;
//     }
//   }
// );



// Thunk for fetching single quize by ID
export const getQuizeWithIDS = createAsyncThunk(
  "getQuizeWithId",
  async (id, thunkAPI) => {
    console.log("QUIZE ID::::0".id);
    try {
      const response = await asyncGetQuizeWithId(id);
      console.log(response);
      return response;
    } catch (error) {
      thunkAPI.dispatch(showToast({ type: "error", msg: error?.msg || "Error fetching quize by ID" }));
      throw error;
    }
  }
);

// Thunk for deleting a quize
export const deleteQuize = createAsyncThunk(
  "deleteQuize",
  async (req, thunkAPI) => {
    try {
      const response = await asyncDeleteQuize(req);
      toast.success("Quize deleted successfully!");
      thunkAPI.dispatch(showToast({ type: "success", msg: response.msg }));
      return response;
    } catch (error) {
      thunkAPI.dispatch(showToast({ type: "error", msg: error.msg }));
      throw error;
    }
  }
);

// Thunk for bulk deleting quizzes
export const bulkDeleteQuize = createAsyncThunk(
  "bulkDeleteQuize",
  async (data, thunkAPI) => {
    try {
      const response = await asyncBulkDeleteQuize(data);
      thunkAPI.dispatch(showToast({ type: "success", msg: response.msg }));
      return data.quizeIds;
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(showToast({ type: "error", msg: error.msg }));
      throw error;
    }
  }
);
